import util from '@bmp-vue/core/api/util'

const controller = 'TipoLayout'
export default Object.assign({}, util.GetCrud(controller, null), {})
